/* eslint-disable */
(function() {
  "use strict";

  const ElmMyInsightsInterop = function() {
    const interop = this;

    // Serializer Engine

    let queryQueue = [];
    let queryRunning = false;
    let userLocale;
    // use explicit style instead of short styles for browser compatibility
    // (Safari does not support short style)
    const shortDateTimeStyleOptions = {
      year: "numeric",
      month: "numeric",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit"
    };

    const translationFormat = "_Translation";

    // Request Handling:

    function makeCallback(jsToElm, queryId) {
      return function(resp) {
        if (queryId) {
          console.log("callback for " + queryId, resp);
          jsToElm.send([queryId, resp]);
        }
      };
    }

    function handleAwarenessForPicklistTranslationsQuery(
      msg,
      callback,
      picklists,
      originalFields
    ) {
      return function(resp) {
        window.ds
          .queryRecord(msg.config)
          .then(
            handlePicklistTranslation(
              msg,
              callback,
              resp,
              picklists,
              originalFields
            ),
            callback
          );
      };
    }

    function handlePicklistTranslation(
      msg,
      callback,
      picklistTranslations,
      picklists,
      originalFields
    ) {
      return function(resp) {
        const hasConfig = msg && msg.config;
        const isSuccessResp = resp && resp.success;
        const hasConfigValue = resp[msg.config.object];
        if (hasConfig && isSuccessResp && hasConfigValue) {
          resp[msg.config.object].forEach(function(respItem) {
            picklists.forEach(function(element, index) {
              let fieldValue;
              let rawValue;
              let fieldMap;
              if (picklistTranslations.length) {
                fieldMap =
                  picklistTranslations[index][msg.config.object][element];
                rawValue = respItem[element];
              }
              if (rawValue) {
                const fieldValueArray = rawValue.split(";");
                if (fieldValueArray.length === 1) {
                  fieldValue = fieldMap[rawValue];
                } else {
                  fieldValue = fieldValueArray
                    .map(val => fieldMap[val])
                    .join(";");
                }
              }
              respItem[element + translationFormat] =
                fieldValue === undefined ? null : fieldValue;
            });
          });
          msg.config.fields = originalFields;
        }
        callback(resp);
      };
    }

    function formatVDSRecordResp(msg, callback) {
      return function(resp) {
        if (!resp[msg.config.object] && resp.data) {
          resp[msg.config.object] = resp.data.records || [];
        }
        callback(resp);
      };
    }

    function getLanguage(locale) {
      const loc = userLocale || locale;
      let lang;
      if (loc) {
        const langArr = loc.split("_");
        lang = langArr.length > 1 ? `${langArr[0]}-${langArr[1]}` : langArr[0];
      }
      return lang || navigator.language;
    }

    function handleElmToJsMsg(jsToElm, msg) {
      // console.log("handling query " + msg.queryId, msg);
      const callback = makeCallback(jsToElm, msg.queryId);
      switch (msg.type) {
        case "getDataForCurrentObject":
          //fails with JSON
          //fails using the success callback
          window.ds
            .getDataForCurrentObject(msg.object, msg.field)
            .then(callback, callback);

          break;

        case "getCurrentUserLocale":
          window.ds
            .getDataForCurrentObject("User", "LocaleSidKey")
            .then(callback, callback);

          break;

        case "getFieldLabels":
          //fails with text
          window.ds
            .getFieldLabels({ object: msg.object, fields: msg.fields })
            .then(callback, callback);

          break;

        case "getObjectLabels":
          //fails with text
          window.ds.getObjectLabels(msg.objects).then(callback, callback);

          break;

        case "getPicklistValueLabels":
          //failures are silently eaten
          //TODO: Some sort of timeout
          window.ds
            .getPicklistValueLabels(msg.object, msg.field)
            .then(callback, callback);

          break;

        case "getVeevaMessages":
          //Best effort.
          //Always succeeds. Drops bad request tokens
          // Uses some default (possibly from user record) when language is bad or missing
          window.ds
            .getVeevaMessagesWithDefault(msg.tokens, msg.language)
            .then(callback, callback);

          break;

        case "runQuery":
          //fails with text
          const runQuerySuccessCallback = function(result) {
            if (result.data.length > 0) {
              const dateFields = [];
              const allFields = Object.keys(result.data[0]);
              for (let k = allFields.length - 1; k >= 0; k--) {
                if (
                  allFields[k] !== "date" &&
                  result.data[0][allFields[k]].dataType === "date"
                ) {
                  dateFields.push(allFields[k]);
                }
              }
              for (let j = dateFields.length - 1; j >= 0; j--) {
                for (let i = result.data.length - 1; i >= 0; i--) {
                  if (result.data[i][dateFields[j]].value === null) {
                    result.data[i][dateFields[j]].value = "";
                  }
                  if (
                    result.data[i][dateFields[j]].dataType === "date" &&
                    result.data[i][dateFields[j]].value &&
                    result.data[i][dateFields[j]].value !== ""
                  ) {
                    result.data[i][dateFields[j]].value = result.data[i][
                      dateFields[j]
                    ].value.toISOString();
                  }
                }
              }
            }
            callback(result);
          };
          window.ds
            .runQuery(msg.config)
            .then(runQuerySuccessCallback, callback);

          break;

        case "querySalesData":
          //fails with text
          window.ds.querySalesData(msg.config).then(callback, callback);

          break;

        case "queryRecord":
          let picklistsPromises = [];
          const picklists = [];
          let originalFields = msg.config.fields;
          msg.config.fields = originalFields.filter(
            word => !word.endsWith(translationFormat)
          );
          originalFields.forEach(word => {
            if (word.endsWith(translationFormat)) {
              let originalField = word.replace(translationFormat, "");
              picklistsPromises.push(
                window.ds.getPicklistValueLabels(
                  msg.config.object,
                  originalField
                )
              );
              picklists.push(originalField);
            }
          });

          Promise.all(picklistsPromises).then(
            handleAwarenessForPicklistTranslationsQuery(
              msg,
              callback,
              picklists,
              originalFields
            ),
            handleAwarenessForPicklistTranslationsQuery(
              msg,
              callback,
              picklists,
              originalFields
            )
          );

          break;

        case "queryVDSRecord":
          //fails using the success callback,
          //on failure, claims to have successfully retrieved nothing
          //TODO: complain to product about this, because we cannot tell success from failure
          window.ds
            .queryVDSRecord(msg.config)
            .then(formatVDSRecordResp(msg, callback), callback);

          break;

        case "editRecord":
          //fire and forget
          window.ds.editRecord({ object: msg.object, fields: msg.fieldValues });

          break;

        case "newRecord":
          //fire and forget
          window.ds.newRecord({ object: msg.object, fields: msg.fieldValues });

          break;

        case "viewRecord":
          //fire and forget
          window.ds.viewRecord({
            object: msg.object,
            fields: msg.fieldValues,
            target: msg.target
          });

          break;

        case "viewSection":
          //fire and forget
          window.ds.viewSection(msg.target);

          break;

        case "getAvailableObjects":
          //does not fail
          window.ds.getAvailableObjects().then(callback, callback);

          break;

        case "getObjectMetadata":
          //fails with text
          window.ds
            .getObjectMetadata({ object: msg.object })
            .then(callback, callback);

          break;

        case "getRecordTypeLabels":
          //fails with text
          window.ds.getRecordTypeLabels(msg.object).then(callback, callback);

          break;

        case "queryDataEngine":
          let formattedConfig = {};
          if (msg.config.fields !== undefined) {
            formattedConfig.fields = msg.config.fields;
          }
          if (msg.config.table !== undefined) {
            formattedConfig.table = msg.config.table;
          }
          if (msg.config.where !== undefined) {
            formattedConfig.where = msg.config.where;
          }
          if (msg.config.sort !== undefined) {
            formattedConfig.sort = msg.config.sort;
          }
          if (msg.config.limit !== undefined) {
            formattedConfig.limit = msg.config.limit;
          }
          window.ds.queryDataEngine(formattedConfig).then(callback, callback);
          break;

        case "FormattedNowRequest": {
          const now = new Date();
          const dateTimeFormatter = Intl.DateTimeFormat(
            getLanguage(msg.locale),
            shortDateTimeStyleOptions
          );
          callback({
            queryId: msg.queryId,
            value: {
              posix: now.getTime(),
              formatted: dateTimeFormatter.format(now)
            }
          });
          break;
        }
        case "getAlignedTerritories":
          window.ds.getAlignedTerritories(msg.config).then(callback, callback);
          break;

        case "getFeedbackData":
          window.ds.getFeedbackData().then(callback, callback);
          break;

        case 'getAttendeeDataForCurrentCall' :
          window.ds.getAttendeeDataForCurrentCall().then(callback, callback);
          break;

        default:
          break;
      }
    }

    function makePortListener(jsToElm) {
      return function(elmToJsMsg) {
        handleElmToJsMsg(jsToElm, elmToJsMsg);
      };
    }

    interop.init = function(elmToJs, jsToElm, locale) {
      elmToJs.subscribe(makePortListener(jsToElm));
      queryQueue = [];
      queryRunning = false;
      userLocale = locale;
    };
  };
  window.ElmMyInsightsInterop = new ElmMyInsightsInterop();
})();
